import { Component, OnInit, NgZone } from "@angular/core";
import { AuthService } from "../../shared/services/auth.service";
import { CachedUserService } from "../../shared/services/cached-user.service";
import { ReplaySubject, Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "app-nav-bar",
    templateUrl: "./nav-bar.component.html",
    styleUrls: ["./nav-bar.component.less"],
    standalone: false
})
export class NavBarComponent implements OnInit {
  private destroy$ = new Subject<void>();

  isActive: boolean = false;
  showFull: boolean = false;
  isBillingUser: boolean = false;
  navHidden: boolean = false;

  private lastScrollY = 0;
  private readonly onScroll = () => {
    const currentY = window.pageYOffset;
    const lastY = this.lastScrollY;
    this.lastScrollY = currentY;
    this.zone.run(() => {
      this.showFull = currentY > 10;
      if (window.innerWidth <= 768) {
        this.navHidden = currentY > lastY && currentY > 60;
      }
    });
  };

  isStaff = false;
  xwaiAccess = false;
  isComputeAdmin = false;
  subscription: Subscription = null;

  constructor(
    public auth: AuthService,
    private userService: CachedUserService,
    private zone: NgZone
  ) {}

  ngOnInit() {
    this.auth.isLoggedIn.pipe(takeUntil(this.destroy$)).subscribe((result) => {
      if (!result) {
        this.isBillingUser = false;
        return;
      }

      this.subscription = this.userService.userDetail
        .pipe(takeUntil(this.destroy$))
        .subscribe((d) => {
          this.isStaff = d && d.isStaff;
          this.xwaiAccess = d && d.xwaiAccess;
          this.isComputeAdmin = !!(d && d.isComputeAdmin);
        });
      this.userService
        .isGroupAdmin()
        .pipe(takeUntil(this.destroy$))
        .subscribe((result) => {
          this.isBillingUser = !!result;
        });
    });

    document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
  }

  expandMenu(event) {
    this.isActive = !this.isActive;
  }

  ngOnDestroy() {
    document.removeEventListener('scroll', this.onScroll, { capture: true });
    this.destroy$.next();
    this.destroy$.complete();
  }
}
